<template>
  <footer class="footer">
    © 2022 PT Lingkar Sembilan Titian Media
  </footer>
</template>
<script>
export default {
  
}
</script>